import { IconEspressoColor, IconNightwatchColor, IconProtractorColor, IconXcuitestColor } from '@saucelabs/ds-icons';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';

import { RDC_DOCUMENTATION_EVENTS } from '../../tracking';

export const INITIAL_RDC_OFFSET = 1;
export const LS_LAST_CLOUD_TYPE = 'lastCloudTypeJobs';
export const REAL_DEVICE_CLOUD = 'real_device_cloud';
export const VIRTUAL_DEVICE_CLOUD = 'virtual_device_cloud';

export const CLOUD_TYPES = [
  ...(isSupportedFeature(features.VDC) ? [VIRTUAL_DEVICE_CLOUD] : []),
  ...(isSupportedFeature(features.RDC) ? [REAL_DEVICE_CLOUD] : []),
];
export const DEFAULT_CLOUD_TYPE = CLOUD_TYPES.find((ct) => ct);

export const TAB_REAL = 'rdc';
export const TAB_VIRTUAL = 'vdc';
export const DEFAULT_TAB = TAB_VIRTUAL;
export const TABS = {
  [TAB_REAL]: REAL_DEVICE_CLOUD,
  [TAB_VIRTUAL]: VIRTUAL_DEVICE_CLOUD,
};
export const CLOUD_TAB_TYPES = [TAB_REAL, TAB_VIRTUAL];

// links to rdc frameworks
export const RDC_ESPRESSO_DEMO = 'https://github.com/saucelabs-training/demo-espresso/';
export const RDC_XCUITEST_DEMO = 'https://github.com/saucelabs/saucectl-xcuitest-example';
export const RDC_NIGHTWATCH_DEMO = 'https://github.com/saucelabs-training/demo-js/tree/main/nightwatch/appium-web/examples/update-sauce-real-devices';
export const RDC_PROTRACTOR_DEMO = 'https://github.com/saucelabs-training/demo-js/tree/main/protractor/appium-web/examples/real-devices';
export const RDC_APPIUM_DOCS = 'https://docs.saucelabs.com/mobile-apps/automated-testing/appium/real-devices/index.html';
export const RDC_ESPRESSO_XCUITEST_DOCS = 'https://docs.saucelabs.com/mobile-apps/automated-testing/espresso-xcuitest/';

export const SAUCE_LABS_TRAINING = 'https://training.saucelabs.com/';

export const RDC_JOB_HELPER_LINKS = [
  {
    icon: IconEspressoColor,
    event: RDC_DOCUMENTATION_EVENTS.ESPRESSO_DEMO,
    name: 'Espresso',
    subtext: 'Android',
    url: RDC_ESPRESSO_DEMO,
    tags: ['Java'],
  },
  {
    icon: IconXcuitestColor,
    event: RDC_DOCUMENTATION_EVENTS.XCUITEST_DEMO,
    name: 'XCUITest',
    subtext: 'iOS',
    url: RDC_XCUITEST_DEMO,
    tags: ['Swift'],
  },
  {
    icon: IconProtractorColor,
    event: RDC_DOCUMENTATION_EVENTS.PROTRACTOR_DEMO,
    name: 'Protractor',
    subtext: 'Appium',
    url: RDC_PROTRACTOR_DEMO,
    tags: ['JavaScript'],
  },
  {
    icon: IconNightwatchColor,
    event: RDC_DOCUMENTATION_EVENTS.NIGHTWATCH_DEMO,
    name: 'NightWatch',
    subtext: 'Appium',
    url: RDC_NIGHTWATCH_DEMO,
    tags: ['JavaScript'],
  },
];

export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE = 1;
